import React from 'react';
import { observer } from 'mobx-react-lite';
import { Responsive } from '../../../../../responsive/responsive';
import { SkeletonTable } from '../../../../table/skeleton-table';

export const SkeletonRealizedAllocationsTable: React.FC = observer(() => {
    return (
        <div className="mb-[-1.6rem] flex min-h-full w-full flex-col items-center gap-small overflow-hidden rounded-medium border border-border bg-body px-medium pt-[5rem] pb-[8rem] max-lg:mb-0 max-lg:gap-vsmall max-lg:border-0 max-lg:bg-transparent max-lg:p-0 max-lg:[&_td]:px-0 max-lg:[&_td]:py-[1.6rem] max-lg:[&_td]:text-vsmall max-lg:[&_th]:px-0 max-lg:[&_th]:py-[1.6rem] max-lg:[&_th]:text-vsmall">
            <Responsive breakpoint={'lg'} type={'min'}>
                <SkeletonTable cols={5} rows={5} />
            </Responsive>
        </div>
    );
});
